<template>
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner-border spinner-border-brand" role="status">
        <span class="sr-only">Загрузка...</span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LoadingOverlay',
    props: {
      isLoading: {
        type: Boolean,
        default: false
      }
    }
  }
  </script>
  
  <style scoped>
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.7);
    z-index: 1050;
  }
  
  .spinner-border {
    width: 3rem;
    height: 3rem;
    z-index: 1060;
  }
  
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
  </style>